import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { RollupContentComponent } from '@fi-shared/rollup/rollup-content.component';

@Component({
    selector: 'fi-wrapper-table-rollup-content-cell',
    template: `
        <fi-rollup-content #rollupContent [minHeight]="minHeight">
            <ng-content />

            <ng-container fi-rollup-content-after>
                @if (rollupContent.canExpand$ | async) {
                    <div class="rollup-content-backdrop" [ngClass]="{ transparent: rollupContent.opened }"></div>
                    <button class="toggle-expansion-button BrandedColor" (click)="toggleContent($event, rollupContent)">
                        {{ (rollupContent.opened ? 'common.show_less' : 'common.show_more') | fiAppText }}
                    </button>
                }
            </ng-container>
        </fi-rollup-content>
    `,
    styleUrl: './fi-wrapper-table-rollup-content-cell.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-rollup-content-cell', '[class.center-content-alignment]': 'centerContentAlignment' },
    standalone: false,
})
export class FiWrapperTableRollupContentCellComponent {
    @Input() minHeight: number = 30;
    @Input() centerContentAlignment: boolean = false;

    toggleContent($event: MouseEvent, rollupContent: RollupContentComponent) {
        $event.stopPropagation();
        rollupContent.toggleContent();
    }
}
